module.exports = __webpack_public_path__ + "static/media/FollowUp.ca111e71.svg";